
   import Vue from 'vue'
   import { Dropdown, Btn } from 'uiv'

   export default Vue.extend({
      name: 'ColourPicker',
      props: {
         id: String,
         value: String,
         label: { type: String, default: 'Colour' },
         size: { type: String, default: '' },
      },
      data() {
         return {
            show: false,

            initialValue: '',
            innerValue: '',
            dirty: false,
            options: [
               { value: 'event-ffffff', colour: '#ffffff' },
               { value: 'event-ffffa9', colour: '#ffffa9' },
               { value: 'event-fff200', colour: '#fff200' },
               { value: 'event-f8ca2f', colour: '#f8ca2f' },
               { value: 'event-e49f11', colour: '#e49f11' },
               { value: 'event-ff8b00', colour: '#ff8b00' },
               { value: 'event-ff4600', colour: '#ff4600' },
               { value: 'event-f8002d', colour: '#f8002d' },
               { value: 'event-d23641', colour: '#d23641' },
               { value: 'event-a9002d', colour: '#a9002d' },
               { value: 'event-e05199', colour: '#e05199' },
               { value: 'event-ec008c', colour: '#ec008c' },
               { value: 'event-ff6199', colour: '#ff6199' },
               { value: 'event-ffb3b9', colour: '#ffb3b9' },
               { value: 'event-ffdbdb', colour: '#ffdbdb' },
               { value: 'event-ffb3d9', colour: '#ffb3d9' },
               { value: 'event-fdccff', colour: '#fdccff' },
               { value: 'event-cf9adf', colour: '#cf9adf' },
               { value: 'event-dcc7ff', colour: '#dcc7ff' },
               { value: 'event-a23cc4', colour: '#a23cc4' },
               { value: 'event-841488', colour: '#841488' },
               { value: 'event-6154d4', colour: '#6154d4' },
               { value: 'event-5a48ad', colour: '#5a48ad' },
               { value: 'event-7b86d5', colour: '#7b86d5' },
               { value: 'event-9aabdf', colour: '#9aabdf' },
               { value: 'event-c4d5fd', colour: '#c4d5fd' },
               { value: 'event-8683a3', colour: '#8683a3' },
               { value: 'event-b3b7c5', colour: '#b3b7c5' },
               { value: 'event-dfdee4', colour: '#dfdee4' },
               { value: 'event-c3e9fc', colour: '#c3e9fc' },
               { value: 'event-00b4ff', colour: '#00b4ff' },
               { value: 'event-01a0d2', colour: '#01a0d2' },
               { value: 'event-006fff', colour: '#006fff' },
               { value: 'event-035eba', colour: '#035eba' },
               { value: 'event-034ade', colour: '#034ade' },
               { value: 'event-b8ffee', colour: '#b8ffee' },
               { value: 'event-50dadc', colour: '#50dadc' },
               { value: 'event-2cab95', colour: '#2cab95' },
               { value: 'event-007986', colour: '#007986' },
               { value: 'event-0091ac', colour: '#0091ac' },
               { value: 'event-008d41', colour: '#008d41' },
               { value: 'event-30a825', colour: '#30a825' },
               { value: 'event-79b800', colour: '#79b800' },
               { value: 'event-bcd500', colour: '#bcd500' },
               { value: 'event-c2ebc1', colour: '#c2ebc1' },
               { value: 'event-86a61c', colour: '#86a61c' },
               { value: 'event-ada343', colour: '#ada343' },
               { value: 'event-d3cd86', colour: '#d3cd86' },
               { value: 'event-a09284', colour: '#a09284' },
               { value: 'event-c0c0c0', colour: '#c0c0c0' },
            ],
         }
      },
      mounted() {
         this.innerValue = this.value
         this.initialValue = this.value
      },
      methods: {
         select(option: { value: string; colour: string }) {
            if (!this.dirty) {
               this.dirty = this.innerValue !== this.value
            }
            this.innerValue = option.value
            this.$emit('input', this.innerValue)
         },
         optionIsSelected(optionValue: string) {
            const match = this.options.find(opt => opt.value === optionValue)
            return !!match
         },
      },
      watch: {
         value(newValue: string) {
            if (newValue !== this.innerValue) {
               this.innerValue = newValue
               this.initialValue = newValue
            }
         },
      },

      components: {
         Dropdown,
         Btn,
      },
   })
